import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { getCrimeTypes } from '../../actions/crimeTypes';
import { AsyncSelect } from '../../components/Forms';

export class CrimeTypeContainer extends Component {
    checkForValidValue = (value) => {
        let match = this.props.crimeTypes.find(type => type.name === value);

        return match && match.id;
    }

    updateInput = value => {
        // If coming from onChange event it's an object.
        let data = value;

        // It's a string from onInputChange. Check if this is a valid option, by finding an ID.
        if(typeof data === 'string') {
            data = {
                name: data,
                id: this.checkForValidValue(data),
            }
        }

        // onBlur for some reason triggers an onInputChange with an empty string, so skip the change if it's an empty string.
        if(!data.name) return;

        this.props.onChange(data);
    }

    getCrimeTypes = () => {
        let { crimeTypes, getCrimeTypes } = this.props;

        if(!!crimeTypes.length) return;

        getCrimeTypes();
    }

    render() {
        let {
            fetching,
            crimeTypes,
            value,
            id
        } = this.props;

        return(
            <AsyncSelect
                value={value}
                options={crimeTypes}
                onMenuOpen={this.getCrimeTypes}
                isLoading={fetching}
                allowCreateWhileLoading={fetching}
                onChange={this.updateInput}
                onInputChange={this.updateInput}
                onSelectResetsInput={false}
                onBlurResetsInput={false}
                onCloseResetsInput={false}
                getOptionLabel={item => item.name}
                getOptionValue={item => item.name}
                id={id}
            />
        );
    }
}

CrimeTypeContainer.propTypes = {
    crimeTypes: PropTypes.array,
    exclude: PropTypes.array,
    fetching: PropTypes.bool,
    disabled: PropTypes.bool,
    value: PropTypes.object,
    getCrimeTypes: PropTypes.func,
    onChange: PropTypes.func,
}

const mapStateToProps = state => {
    return {
        crimeTypes: state.crimeTypes.data,
        fetching: state.crimeTypes.fetching,
    };
};

const mapDispatchToProps = dispatch => bindActionCreators({ getCrimeTypes }, dispatch);

export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(CrimeTypeContainer));